import {
  TOrderSettingsTabKey,
} from '@/page/orders/order-settings.ts';

const tabs: Record<TOrderSettingsTabKey, string> = {
  attributes: 'Attributes',
  tableView: 'Overview Table',
};
export default {
  tabs,
};
